import { Button, ButtonProps, Tooltip } from "@mantine/core";
import styles from "./FloatingActionButton.module.css";

interface FloatingActionButtonProps extends Omit<ButtonProps, "size" | "variant" | "radius"> {
  /**
   * Children to render inside the button
   */
  children: React.ReactNode;
  /**
   * Tooltip text to show on hover
   */
  tooltip?: string;
  /**
   * Aria label for accessibility
   */
  ariaLabel: string;
  /**
   * Click handler
   */
  onClick: (e: React.MouseEvent) => void;
}

/**
 * A floating action button with consistent styling
 * Extracts the repeated FAB pattern from PrioritiesTrigger
 */
function FloatingActionButton({ children, tooltip, ariaLabel, onClick, ...props }: FloatingActionButtonProps) {
  const button = (
    <Button
      aria-label={ariaLabel}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
      type="button"
      size="lg"
      variant="filled"
      radius="xl"
      px="md"
      py="sm"
      className={styles.fab}
      {...props}
    >
      {children}
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip label={tooltip} position="left" withArrow>
        {button}
      </Tooltip>
    );
  }

  return button;
}

export default FloatingActionButton;
